import { render, staticRenderFns } from "./ThreeRenderer.vue?vue&type=template&id=b5db13fc&scoped=true"
import script from "./ThreeRenderer.vue?vue&type=script&lang=ts"
export * from "./ThreeRenderer.vue?vue&type=script&lang=ts"
import style0 from "./ThreeRenderer.vue?vue&type=style&index=0&id=b5db13fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5db13fc",
  null
  
)

export default component.exports